import React, {VoidFunctionComponent} from "react";

interface Props {
    title: string,
    content: string,
    imageUrl: string,
    imageAlt: string
}

export const Document: VoidFunctionComponent<Props> = ({title, content, imageUrl, imageAlt}) => {

    return (
        <div className='document'>
            <img src={imageUrl} alt={imageAlt}/>
            <div>
                <p className='title'>{title}</p>
                <p className='content'>{content}</p>
            </div>
        </div>
    );
};